const initTwoColumnsText = () => {
	const sections = document.querySelectorAll( 'section.two-columns-text' );

	if ( sections.length ) {
		Array.from( sections ).forEach( ( section ) => {
            if ( !section ) {
                return;
            }
            const userAgent = navigator.vendor;
			const elements = section.querySelector( '.markup' );

			if ( elements && userAgent === "Google Inc." && elements.childNodes.length === 2 ) {
                section.classList.add( 'two-elements' );
            }
		}) 
	}
}

export {
	initTwoColumnsText,
};